import classNames from 'classnames';
import React, { useState } from 'react';
import { Popover, Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { RULER_UNIT_LIST } from '../constants';
import { useRulerState } from '../states/ruler-state';
import './unit-button.less';

const UnitButton: React.FC = () => {
    const rulerUnit = useRulerState()((state) => state.rulerUnit);
    const setRulerUnit = useRulerState()((state) => state.setRulerUnit);
    const { $t } = useLocaleStore();

    const [showUnitPopover, setShowUnitPopover] = useState(false);
    const [showUnitTooltip, setShowUnitTooltip] = useState(false);

    function getUnitListItems() {
        return (
            <ul>
                {RULER_UNIT_LIST.map((unit) => {
                    return (
                        <li
                            key={unit}
                            className={classNames({
                                selected: unit === rulerUnit,
                            })}
                            onClick={() => {
                                setRulerUnit(unit);
                                setShowUnitPopover(false);
                            }}
                        >
                            <span className="unit-name">{unit}</span>
                            {unit === rulerUnit && <IconFont name="CheckBlack" fontSize={14} />}
                        </li>
                    );
                })}
            </ul>
        );
    }

    return (
        <Tooltip
            placement="bottom"
            title={$t((v) => v.rulerBarPlugin.switchStageUnit)}
            trigger="hover"
            onOpenChange={(open) => {
                setShowUnitTooltip(open);
            }}
            open={showUnitTooltip}
        >
            <Popover
                onOpenChange={(open) => {
                    setShowUnitPopover(open);
                    setShowUnitTooltip(false);
                }}
                open={showUnitPopover}
                content={getUnitListItems()}
                trigger="click"
                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                placement="bottom"
                overlayClassName="switch-stage-unit-menu"
            >
                {rulerUnit}
            </Popover>
        </Tooltip>
    );
};

export default React.memo(UnitButton);
